import { stats } from "@/mocks/categories";
import { useNavigate } from "react-router-dom";

export default function AboutSEO() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="flex-1 max-w-xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-information-line"></i>
              What is Pandabuy Sheet?
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6 leading-tight">
              Your Ultimate Guide to{" "}
              <span className="text-accent-500">Pandabuyspreadsheet</span>
            </h2>
            <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                The <strong>pandabuyspreadsheet</strong> is more than just a list — it&apos;s a
                carefully organized collection of the best fashion and sneaker finds, structured
                into smart comparison tables that help you make better buying decisions in seconds.
              </p>
              <p>
                Unlike random TikTok links or messy forum threads, our{" "}
                <strong>pandabuyspreadsheet hub</strong> gives you verified listings with ratings,
                price ranges, and daily updates. Whether you&apos;re looking for budget sneakers
                under $50, viral streetwear, or luxury-style accessories, every category is
                organized for speed and clarity.
              </p>
              <p>
                Built for both beginners and seasoned shoppers, the{" "}
                <strong>pandabuyspreadsheet</strong> system is the fastest way to discover trending
                products before they blow up on social media. No spam, no duplicates — just clean,
                structured data that works.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mt-8">
              <button
                onClick={() => { navigate("/pandabuyspreadsheet-guide"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Read Full SEO Guide
                <i className="ri-arrow-right-line text-base"></i>
              </button>
            </div>

            <div className="flex gap-12 mt-10">
              {stats.slice(0, 2).map((stat) => (
                <div key={stat.label}>
                  <div className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-400 mt-1 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 relative">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] max-w-md mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Sunlit%20Mediterranean%20balcony%20with%20neatly%20folded%20neutral%20toned%20linen%20clothing%20on%20a%20rattan%20chair%2C%20terracotta%20potted%20plants%2C%20warm%20golden%20afternoon%20light%2C%20peaceful%20coastal%20interior%20with%20organic%20textures%2C%20editorial%20photography%20with%20soft%20shadows%20and%20airy%20atmosphere&width=800&height=1000&seq=about-v2-lifestyle&orientation=portrait"
                alt="Pandabuyspreadsheet lifestyle fashion scene"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm">
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">
                  Editor&apos;s Pick
                </span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-background-50 text-sm font-medium">Curated Daily</p>
                <p className="text-background-50/70 text-xs">Fresh spreadsheet updates</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}